import { Injectable } from '@angular/core';

// global.d.ts or a similar file
declare global {
  interface Window {
    umami: any; // or a more specific type if you know the structure of umami
  }
}


@Injectable({
  providedIn: 'root'
})
export class UmamiService {

  constructor() { }

  // Load the Umami script dynamically
  public loadUmamiScript(websiteId: string) {
    if (websiteId && !window.umami) {

      const umamiScript = document.createElement('script');
      umamiScript.defer = true;
      umamiScript.src = 'https://cloud.umami.is/script.js';
      umamiScript.setAttribute('data-website-id', websiteId);
      umamiScript.setAttribute('data-auto-track', 'false');

      document.head.appendChild(umamiScript);
    }
  }

  public trackEvent(eventName: string, eventData: any = {}) {
    if (window.umami) {
      window.umami.track(eventName, eventData);
    }
    // If umami is not loaded, simply do nothing (no warnings or logs)
  }


  public trackPage() {
    if (window.umami) {
      window.umami.track();
    }
  }

  public identify(id: string, data: any = {}) {
    if (window.umami) {
      window.umami.identify(id, data);
    }
  }  

}
